import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { DialogMemo } from 'components/dialog';
import { primitive } from 'styles/constants/primitives';

export const Modal = styled(DialogMemo)`
  &.loyalty-tiers-modal {
    width: calc(100% - 2rem);
  }

  ${Styles.desktop} {
    &.loyalty-tiers-modal {
      width: auto;
    }
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
`;

export const ContinueButton = styled(ActionButton)`
  margin-block-start: 1rem;
  font-size: 1rem;
`;

export const CloseButton = styled(ActionButton)`
  margin-block-start: 1rem;
  margin-block-end: 0.5rem;
  font-size: 1rem;
  color: ${primitive.bk.$bbqBrown};
`;

export const Heading = styled.div`
  text-align: start;
`;

export const Description = styled.div`
  text-align: start;
`;
